[...document.querySelectorAll('.js-project')].forEach((item) => {
    const   triggers = item.querySelectorAll('.js-project-filter-trigger'),
            targets = item.querySelectorAll('.js-project-filter-target'),
            show_class = 'show';

    if ( triggers && targets ) {
        filterSelection();

        [...triggers].forEach( ( trigger ) => {
            trigger.addEventListener( 'click', () => filterSelection( trigger.dataset.selection ) );
        } );

        function filterSelection( filter_slug = '' ) {
            targets.forEach( ( target ) => {
                target.classList.remove( show_class );
                
                if ( target.classList.contains( filter_slug ) || filter_slug === '' ) target.classList.add( show_class );
            } );
        }
    } 
} );